import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function ButtonsPromptNode({ id, data }) {
    return (
        <NodeComponent title="Buttons" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
            <div></div>
        </NodeComponent>
    );
}

